<template>
  <div class="ret-cards-wrapper">
    <v-card class="ret-header-card">
      <v-card-title>
        <v-layout row>
          <v-flex xs6 md3>
            <v-text-field
              clearable
              hide-details
              solo
              v-model="search"
              :label="$t('search')"
              append-icon="search"
              data-test="search"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md3>
            <v-switch
              v-model="showArchived"
              input-value="true"
              :label="$t('archived')"
              class="mt-2"
              data-test="archived"
            ></v-switch>
          </v-flex>
          <v-flex grow class="text-right">
            <v-btn color="accent" fab small dark @click="createItem" data-test="create-user-groups">
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>

    <v-card class="ret-card-new">
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="pagedItems"
          :server-items-length="totalItems"
          :footer-props="{ 'items-per-page-text': $t('rows-per-page'), 'items-per-page-options': [10,20,50,100,{ text: $t('all'), value: -1 }] }"
          :no-data-text="$t('no-data-available')"
          :options.sync="options"
          :loading="loading"
        >
          <template slot="item" slot-scope="props">
            <tr @click="editItem(props.item)">
              <td>{{ props.item.name }}</td>
              <td v-if="props.item.archivedAt">
                <v-btn text icon small :title="$t('restore')" @click.stop="restoreItem(props.item)">
                  <v-icon>delete_forever</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Create/Edit form -->
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card data-test="user-group-dialog">
        <v-toolbar flat>
          {{ $t(editedItem.id ? 'user-group.edit' : 'user-group.new') }}
          <v-spacer />
          <v-btn
            v-if="editedItem.id"
            text
            small
            color="red"
            @click="onDestroy(editedItem)"
            data-test="archive"
          >{{ $t('archive') }}</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form @keyup.enter="saveForm">
            <v-text-field
              v-model="editedItem.name"
              ref="name"
              :label="$t('name')"
              data-test="user-groups-name"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="hideForm" data-test="cancel">{{ $t('cancel') }}</v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            :loading="loading"
            :disabled="saveDisabled"
            @click="saveForm"
            data-test="save-user-group"
          >{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import lazyItems from '../helpers/lazy-items.es6'
import commonHelpers from '../helpers/common-helpers.es6'

export default {
  mixins: [lazyItems, commonHelpers],
  data () {
    return {
      model: {
        name: 'user-groups',
        searchColumns: ['name']
      },
      defaultHeaders: [
        { text: this.$t('name'), value: 'name' }
      ],
      dialog: false,
      editedItem: {},
      loading: false
    }
  },
  computed: {
    saveDisabled () {
      return !this.editedItem.name
    }
  },
  methods: {
    createItem () {
      this.editedItem = { name: '' }
      this.showForm()
    },
    editItem (item) {
      this.editedItem = { ...item }
      this.showForm()
    },
    showForm () {
      this.dialog = true
      this.$nextTick(() => {
        this.$refs['name'].focus()
      })
    },
    hideForm () {
      this.dialog = false
    },
    async saveForm () {
      const modelName = this.model.name
      const item = { ...this.editedItem }
      try {
        this.loading = true
        await this.$store.dispatch('updateItem', {
          modelName,
          item
        })
        this.$store.commit('showSnackbar', {
          message: this.$t('saved')
        })
        this.reRoute()
      } catch (error) {
        console.error(error)
        this.$store.commit('showSnackbar', {
          message: this.$t('something-went-wrong'),
          timeout: 0
        })
      } finally {
        this.loading = false
      }
    },
    reRoute () {
      this.hideForm()
      this.updateIndex()
    }
  }
}
</script>
